import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import UserRegistrationForm from "../components/UserRegistrationForm";
import { sendTestResultsEmail } from "../services/emailService";
import { calculateORS } from "../services/testCalculations";

const questions = [
  {
    concept: "Скорость",
    options: [
      { text: "быстрая смена пейзажа, мелькание деревьев, домов", type: "V" },
      { text: "шум ветра, шуршание шин, визг тормозов", type: "A" },
      { text: "учащенное сердцебиение; ощущение ветра, бьющего в лицо", type: "K" },
      { text: "200 км/ч на спидометре, высокий расход топлива", type: "D" }
    ]
  },
  {
    concept: "Плохая погода",
    options: [
      { text: "завывание ветра, стук капель", type: "A" },
      { text: "неподходящее время для прогулок", type: "D" },
      { text: "зябко, ощущение сырости, влажный воздух", type: "K" },
      { text: "тусклое небо, серые тучи", type: "V" }
    ]
  },
  {
    concept: "Мед",
    options: [
      { text: "полезный для здоровья продукт, много витаминов", type: "D" },
      { text: "сладкий запах, липкие губы, тягучий", type: "K" },
      { text: "золотистая, прозрачная жидкость", type: "V" },
      { text: "хлопок открывающейся банки, звон ложек, жужжание пчел", type: "A" }
    ]
  },
  {
    concept: "Море",
    options: [
      { text: "сине-зеленая вода, большие волны с белыми гребешками", type: "V" },
      { text: "теплая, соленая вода, горячий песок", type: "K" },
      { text: "шум прибоя, шелест волн, крики чаек", type: "A" },
      { text: "вода более плотная из-за соли, быстро заживляет раны", type: "D" }
    ]
  },
  {
    concept: "Усталость",
    options: [
      { text: "тело ломит, голова тяжелая, вялость", type: "K" },
      { text: "работоспособность снижается, появляется утомляемость", type: "D" },
      { text: "мир вокруг кажется серым, бесцветным, пелена перед глазами", type: "V" },
      { text: "громкие звуки раздражают, хочется тишины", type: "A" }
    ]
  },
  {
    concept: "Яблоко",
    options: [
      { text: "звонкий хруст укуса", type: "A" },
      { text: "круглый плод, красного, желтого или зеленого цвета на высоком дереве", type: "V" },
      { text: "кисло-сладкий, сочный вкус, запах варенья", type: "K" },
      { text: "содержит много витамина С", type: "D" }
    ]
  },
  {
    concept: "Снег",
    options: [
      { text: "ледяные кристаллики, выпадающие из облаков при температуре ниже 0 градусов", type: "D" },
      { text: "сверкающее, искрящееся на солнце белое покрывало", type: "V" },
      { text: "холодный, мягкий, пушистый", type: "K" },
      { text: "скрипит под ногами, потрескивание наста", type: "A" }
    ]
  },
  {
    concept: "Вечер",
    options: [
      { text: "размытые краски, яркие огни фонарей, длинные тени", type: "V" },
      { text: "период суток после 17-18 часов", type: "D" },
      { text: "приглушенные звуки, голоса близких, шкварчащий на сковороде ужин", type: "A" },
      { text: "ощущение приятной усталости, мягкое удобное кресло, чашка горячего чая", type: "K" }
    ]
  },
  {
    concept: "У костра",
    options: [
      { text: "тепло, дым щиплет глаза, согревает", type: "K" },
      { text: "языки красного пламени, вспыхивающие угли, сизый дым", type: "V" },
      { text: "открытая форма разведения огня для подогрева пищи или обогрева", type: "D" },
      { text: "потрескивание углей, шипение дров, бульканье воды в котелке", type: "A" }
    ]
  },
  {
    concept: "Дерево",
    options: [
      { text: "шелест листьев, треск сучьев, скрип веток", type: "A" },
      { text: "высокий прямой коричневый ствол, зеленая крона, лучи солнца проглядывают сквозь листву", type: "V" },
      { text: "шершавая кора, мягкая листва, запах свежести", type: "K" },
      { text: "многолетнее растение с одревесневшим главным стеблем (столбом)", type: "D" }
    ]
  },
  {
    concept: "Библиотека",
    options: [
      { text: "публичное место, где хранятся книги, газеты и журналы", type: "D" },
      { text: "шорох страниц, приглушенная речь, скрип стульев", type: "A" },
      { text: "книги с гладкими обложками, увесистые тома, запах старых книг", type: "K" },
      { text: "глянцевые и матовые, красочные и разноцветные обложки книг; высокие стеллажи", type: "V" }
    ]
  },
  {
    concept: "Город",
    options: [
      { text: "завлекающие витрины магазинов, разнообразие и смешение различных запахов", type: "K" },
      { text: "высокие здания, серые мостовые, яркие рекламные щиты, разноцветные машины", type: "V" },
      { text: "шум машин, гул голосов, вой сирены, хлопанье дверей", type: "A" },
      { text: "населенный пункт, жители которого обычно не заняты в хозяйстве", type: "D" }
    ]
  },
  {
    concept: "Утро",
    options: [
      { text: "светло-голубое небо, прозрачный воздух, показавшееся из-за горизонта розовое солнце", type: "V" },
      { text: "щебетание птиц, тишина, тихое шуршание листьев", type: "A" },
      { text: "период времени с 6 до 12 часов", type: "D" },
      { text: "прохладный воздух, влажная трава, теплые лучи солнца, дышится полной грудью", type: "K" }
    ]
  },
  {
    concept: "Ремонт",
    options: [
      { text: "текущий, средний, капитальный", type: "D" },
      { text: "запах пыли, краски, лака; влажные свежепоклеенные обои", type: "K" },
      { text: "чистые обои, белый потолок, беспорядок", type: "V" },
      { text: "стук молотка, визг дрели, эхо в пустых комнатах", type: "A" }
    ]
  },
  {
    concept: "Церковь",
    options: [
      { text: "огоньки свечей, золото алтаря, тусклые краски старинных икон, полумрак", type: "V" },
      { text: "религиозная организация, последователи, вероучение", type: "D" },
      { text: "монотонный голос богослужителя, хоровое пение, потрескивание свечей", type: "A" },
      { text: "сладкий запах ладана, запах горящего воска, ощущение умиротворения", type: "K" }
    ]
  },
  {
    concept: "Потребность какого из центров является для вас наиболее актуальной в жизни",
    options: [
      { text: "потребность в принятии, в том, чтобы другие люди обращали на вас внимание, хорошо вас оценивали и хорошо к вам относились", type: "A" },
      { text: "потребность в безопасности, в том, чтобы будущее было предсказуемым, прогнозируемым", type: "K" },
      { text: "потребность в уважении/границах, в том, чтобы другие люди считались с вами и с вашим мнением", type: "D" }
    ]
  },
  {
    concept: "Какая из базовых эмоциональных реакций является для вас наиболее привычной",
    options: [
      { text: "стыд – насколько часто в жизни вы испытываете чувство смущения или стыда, когда вам кажется, что другие люди оценивают вас не совсем так, как вы бы этого хотели, или когда вам кажется, что другие люди вас не принимают", type: "A" },
      { text: "страх – насколько часто в жизни вы испытываете чувство тревоги, страха или смутное ощущение того, что что-то может пойти не так, что с вами может случиться что-то неприятное", type: "K" },
      { text: "гнев – насколько часто в жизни вы испытываете раздражение или злость по отношению к другим людям, из-за того, что они не совсем считаются с вашим мнением, или не всегда уважают ваши границы", type: "D" }
    ]
  },
  {
    concept: "Если все ваше время и энергию взять за 100%, то",
    options: [
      { text: "Сколько времени и энергии вы тратите на обеспечение и поддержание физической безопасности и комфорта? (еду, одежду, деньги, жилье, здоровье)", type: "K" },
      { text: "Сколько времени и энергии вы тратите на совместную (групповую) деятельность, на то, чтобы быть частью группы, чтобы быть принятым ей? (семьей, командой, профессиональным сообществом или любой другой группой)", type: "A" },
      { text: "Сколько времени и энергии Вы тратите на поиски/выстраивание отношений с другим человеком – насколько для Вас важна близость? (с партнером, другом)", type: "D" }
    ]
  },
  {
    concept: "Что для вас является самым серьезным жизненным стрессом",
    options: [
      { text: "Лишиться стабильности, безопасности и комфорта в жизни – потерять привычный источник дохода, столкнуться с предстоящей неизвестностью", type: "K" },
      { text: "Лишиться принадлежности к важной для вас группе – потерять статус, свое положение в группе, или оказаться исключенным из группы", type: "A" },
      { text: "Потерять свою «вторую половину» или так ее и не встретить в жизнь – прожить жизнь в одиночестве, без настоящей любви и близости", type: "D" }
    ]
  }
];

const ORSTest = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [userInfo, setUserInfo] = useState({
    full_name: "",
    email: "",
    phone: ""
  });
  const [isStarted, setIsStarted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleStart = () => {
    setIsStarted(true);
  };

  const handleAnswerChange = (optionIndex) => {
    setAnswers({
      ...answers,
      [currentQuestion + 1]: optionIndex
    });
  };

  const nextQuestion = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const prevQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === 'Return') {
      if (currentAnswer !== undefined) {
        if (isLastQuestion) {
          submitTest();
        } else {
          nextQuestion();
        }
      }
    }
  };

  const submitTest = async () => {
    setIsSubmitting(true);
    try {
      // Calculate results on frontend
      const testResult = calculateORS(answers);
      testResult.userInfo = userInfo;
      testResult.testType = 'ors';
      testResult.answers = answers; // Добавляем исходные ответы для детального отображения
      testResult.summary = `Ваша доминирующая репрезентативная система: ${testResult.dominantSystem}`;
      
      // Send email with detailed results
      const emailResult = await sendTestResultsEmail(testResult, 'ors');
      
      if (emailResult.success) {
        console.log('✅ Email sent successfully');
        if (emailResult.excelCreated) {
          console.log(`📊 Excel file created: ${emailResult.excelFileName}`);
        }
      } else {
        console.error('❌ Email sending failed:', emailResult.error);
      }
      
      // Excel файл для теста ORS не поддерживается
      console.log('📊 Excel файл для теста ORS не создается (не поддерживается)');
      
      // Store results for display
      const displayResult = {
        id: Date.now().toString(),
        test_type: 'ors',
        user_info: userInfo,
        results: {
          allSystems: testResult.allSystems,
          dominantSystem: testResult.dominantSystem,
          topSystems: testResult.topSystems
        },
        timestamp: new Date().toISOString()
      };
      
      // Store in localStorage for display
      localStorage.setItem('lastTestResult', JSON.stringify(displayResult));
      
      // Navigate to thank you page
      navigate('/thank-you');
      
    } catch (error) {
      console.error("Error submitting test:", error);
      alert("Ошибка при отправке результатов. Попробуйте еще раз.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isStarted) {
    const testDescription = (
      <div className="mb-6 p-4 bg-red-50 rounded-md">
        <h3 className="font-semibold text-red-800 mb-2">О тесте:</h3>
        <p className="text-red-700 text-sm mb-2">
          Тест на определение ОРС (Основной Репрезентативной Системы) поможет определить, 
          как вы лучше всего воспринимаете и обрабатываете информацию.
        </p>
        <p className="text-red-700 text-sm mb-2">
          Выберите из данных словосочетаний одно, которое, по вашему мнению, является наиболее подходящим, 
          точным для Вас к данному понятию.
        </p>
        <p className="text-red-700 text-sm">
          Если несколько словосочетаний кажутся вам одинаково подходящими или наоборот, ни одно не подходит 
          абсолютно точно, выберете то одно словосочетание, которое может быть наиболее близким.
        </p>
      </div>
    );

    return (
      <UserRegistrationForm
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        onStart={handleStart}
        testTitle="Тест на определение ОРС"
        testDescription={testDescription}
        buttonText="Начать тест (19 вопросов)"
      />
    );
  }

  const isLastQuestion = currentQuestion === questions.length - 1;
  const currentAnswer = answers[currentQuestion + 1];
  const currentQuestionData = questions[currentQuestion];

  return (
    <div className="container mx-auto px-4 py-8" onKeyPress={handleKeyPress} tabIndex={0}>
      <div className="max-w-3xl mx-auto">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <ProgressBar current={currentQuestion + 1} total={questions.length} className="mb-8" />
          
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Вопрос {currentQuestion + 1}
            </h2>
            <p className="text-gray-700 text-lg mb-6">
              <strong>«{currentQuestionData.concept}»</strong>
            </p>
            
            <div className="mb-4 p-3 bg-blue-50 rounded-md">
              <p className="text-blue-800 text-sm">
                💡 <strong>Подсказка:</strong> Выберите наиболее подходящий вариант и нажмите Enter для перехода к следующему вопросу.
              </p>
            </div>
            
            <div className="space-y-3">
              {currentQuestionData.options.map((option, index) => (
                <label key={index} className="flex items-start cursor-pointer p-3 border border-gray-200 rounded-md hover:bg-blue-50 hover:border-blue-300 transition-colors">
                  <input
                    type="radio"
                    name={`question-${currentQuestion}`}
                    value={index}
                    checked={currentAnswer === index}
                    onChange={() => handleAnswerChange(index)}
                    onKeyPress={handleKeyPress}
                    className="mr-3 mt-1 text-blue-600 focus:ring-blue-500"
                  />
                  <span className="text-gray-700">
                    {String.fromCharCode(97 + index)}) {option.text}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="flex justify-between">
            <button
              onClick={prevQuestion}
              disabled={currentQuestion === 0}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Назад
            </button>
            
            {isLastQuestion ? (
              <button
                onClick={submitTest}
                disabled={isSubmitting || currentAnswer === undefined}
                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? "Отправка..." : "Завершить тест"}
              </button>
            ) : (
              <button
                onClick={nextQuestion}
                disabled={currentAnswer === undefined}
                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Далее
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ORSTest;